"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interviewLoginMethodValues = void 0;
/**
 * How the participant authenticated. Computed in the interview/participant join
 * from google_id, the username prefix (`telephone_`, `anonym_`), then email.
 * A remaining username is `byField` when that auth method is enabled.
 */
exports.interviewLoginMethodValues = [
    'email',
    'anonymous',
    'google',
    'interviewer',
    'byField',
    'unknown'
];
//# sourceMappingURL=Data.js.map